export class Microsoft365TeamSelectedItemsOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<SaasRestoreItem>",
            "format": ""
        },
        {
            "name": "newChannelName",
            "baseName": "newChannelName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365TeamSelectedItemsOptions.attributeTypeMap;
    }
    constructor() {
    }
}
